import React from 'react';
import {PropTypes} from 'prop-types';
import {connect} from 'react-redux';
import DialogueTitle from 'components/DialogueTitle';
import DialogueButtons from 'components/DialogueButtons';
import Modal from 'react-modal';
import Resources from 'utilities/Resources';
import 'styles/exports.scss';

class EditVehicleGroupErrorDialogue extends React.Component {
  static propTypes = {
    showUpdateVehicleGroupDialogue: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
  };

  close = () => {
    this.props.onClose();
  };

  render() {
    const resources = Resources.localizedString;
    return (
      <Modal
      className={"dialogue"}
      contentLabel="Update Vehical Group Error Modal"
      onRequestClose={this.onClose}
      onClose={this.onclose}
      isOpen={this.props.showUpdateVehicleGroupDialogue}
      style={{
        content: {
          width: 950,
          height: 370
        }
      }}>
        <DialogueTitle title="Save Failed" />
        <div className="padded margin-vertical">
          <div className="padded margin-vertical text-center">
            <span className="status-icon status-icon--error margin-bottom"></span>
            <p className="margin-top">{resources.anErrorOccurredSavingVehicleGroup}</p>
            <p>{resources.pleaseTryAgainInFewMinutes}</p>
          </div>
        </div>
        <DialogueButtons
          showCancelButton={false}
          confirmFunction={this.close}
          confirmButtonText={resources.ok} />
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
  };
}
export {EditVehicleGroupErrorDialogue as EditVehicleGroupErrorDialogueNoRedux};

const ConnectedEditVehicleGroupErrorDialogue = connect(mapStateToProps, mapDispatchToProps)(EditVehicleGroupErrorDialogue);
export default ConnectedEditVehicleGroupErrorDialogue;